module.exports = __webpack_public_path__ + "img/tuoyuand.ceb22d2a.png";